export const miRates = (creditScore, ltv, offeringId) => {
  if (offeringId === 1) {
    if (ltv > 0.8) {
      if (creditScore <= 639) {
        if (ltv > 0.95) {
          return 1.15;
        } else if (ltv > 0.9) {
          return 1.15;
        } else if (ltv > 0.85) {
          return 0.79;
        }
        return 0.35;
      } else if (creditScore <= 659) {
        if (ltv > 0.95) {
          return 1.05;
        } else if (ltv > 0.9) {
          return 1.05;
        } else if (ltv > 0.85) {
          return 0.75;
        }
        return 0.33;
      } else if (creditScore <= 679) {
        if (ltv > 0.95) {
          return 0.93;
        } else if (ltv > 0.9) {
          return 0.93;
        } else if (ltv > 0.85) {
          return 0.71;
        }
        return 0.32;
      } else if (creditScore <= 699) {
        if (ltv > 0.95) {
          return 0.58;
        } else if (ltv > 0.9) {
          return 0.58;
        } else if (ltv > 0.85) {
          return 0.48;
        }
        return 0.22;
      } else if (creditScore <= 719) {
        if (ltv > 0.95) {
          return 0.45;
        } else if (ltv > 0.9) {
          return 0.45;
        } else if (ltv > 0.85) {
          return 0.34;
        }
        return 0.16;
      } else if (creditScore <= 739) {
        if (ltv > 0.95) {
          return 0.36;
        } else if (ltv > 0.9) {
          return 0.36;
        } else if (ltv > 0.85) {
          return 0.27;
        }
        return 0.13;
      } else if (creditScore <= 759) {
        if (ltv > 0.95) {
          return 0.3;
        } else if (ltv > 0.9) {
          return 0.3;
        } else if (ltv > 0.85) {
          return 0.22;
        }
        return 0.11;
      } else if (ltv > 0.95) {
        return 0.2;
      } else if (ltv > 0.9) {
        return 0.2;
      } else if (ltv > 0.85) {
        return 0.16;
      }
      return 0.1;
    }
    return 0;
  } else if (offeringId === 2) {
    if (ltv > 0.95) {
      return 0.55;
    }
    return 0.5;
  } else if (offeringId === 3) {
    return 0;
  } else if (offeringId === 7) {
    return 0.35;
  }
  return 0;
};

export const mortgageInsurance = (loanAmount, homePrice, mIrate, upFrontMI, offeringId) => {
  if (loanAmount > 0.78 * homePrice || offeringId === 2) {
    return (mIrate / 12 / 100) * (loanAmount - upFrontMI);
  }
  return 0;
};

export const mortgageInsuranceAmort = (loanAmount, mIrate) => {
  return (mIrate / 12 / 100) * loanAmount;
};

export const titleAmount = (homePrice, title) => {
  return (title / 100) * homePrice;
};

export const payment = (loanAmount, interestRate, period) => {
  return Number((loanAmount * (interestRate / 100 / 12)) / (1 - (1 + interestRate / 100 / 12) ** (period * -12)));
};

export const inFiveYearTotal = (
  loanAmount,
  interestRate,
  homePrice,
  upfrontCharges,
  upFrontMI,
  mIrate,
  period,
  titleAmt,
  appraisal,
  otherFees,
  offeringId,
) => {
  let prin = Number(loanAmount);
  const mon = payment(loanAmount, interestRate, period);
  let totalMi = 0;

  if (offeringId === 1) {
    for (let i = 0; i < 60; i += 1) {
      if (prin >= 0.78 * Number(homePrice)) {
        totalMi += Number(mortgageInsuranceAmort(prin, mIrate));
      }
      prin -= mon - (Number(interestRate) / 12 / 100) * prin;
    }
  } else {
    for (let i = 0; i < 60; i += 1) {
      totalMi += Number(mortgageInsuranceAmort(prin, mIrate));
      prin -= mon - (Number(interestRate) / 12 / 100) * prin;
    }
  }

  return Math.round(
    Number(payment(loanAmount, interestRate, period)) * 60 +
      totalMi +
      Number(upfrontCharges) +
      Number(upFrontMI) +
      Number(titleAmt) +
      Number(appraisal) +
      Number(otherFees),
  );
};

export const inFiveYearPrincipal = (loanAmount, interestRate, period) => {
  let prin = loanAmount;
  const mon = payment(loanAmount, interestRate, period);
  for (let i = 0; i < 60; i += 1) {
    prin -= mon - (interestRate / 12 / 100) * prin;
  }
  return Math.round(loanAmount - prin);
};

export const calculateApr = (
  loanAmount,
  interestRate,
  upfrontCharges,
  upFrontMI,
  period,
  homePrice,
  mIrate,
  offeringId,
) => {
  let ap = Number(interestRate);
  let ap2 = Number(interestRate) + 0.1;
  let prin = Number(loanAmount);
  let prinGovyBase = Number(loanAmount) - Number(upFrontMI);
  const mon = payment(loanAmount, interestRate, period);
  const monGovyBase = payment(Number(loanAmount) - Number(upFrontMI), interestRate, period);
  const financedAmt = Number(loanAmount) - Number(upFrontMI) - Number(upfrontCharges);
  let totalMi = 0;
  let totalMi2 = 0;
  let discountedPmt = 0;
  let discountedPmt2 = 0;
  let totalAprPmt = 0;
  let totalAprPmt2 = 0;
  let iDiff = 0.1;

  if (interestRate > 0) {
    while (Math.abs(Number(discountedPmt) + Number(totalMi) - Number(financedAmt)) > 1) {
      ap += Number(iDiff);
      ap2 = ap + 0.1;
      if (ap > 15) {
        break;
      }

      prin = Number(loanAmount);
      prinGovyBase = Number(loanAmount) - Number(upFrontMI);
      totalMi = 0;
      totalMi2 = 0;
      discountedPmt = 0;
      discountedPmt2 = 0;

      if (offeringId === 1) {
        for (let i = 0; i < period * 12; i += 1) {
          if (prin >= 0.78 * Number(homePrice)) {
            totalMi += Number(mortgageInsuranceAmort(prin, mIrate)) / (1 + Number(ap) / 100 / 12) ** (i + 1);
            totalMi2 += Number(mortgageInsuranceAmort(prin, mIrate)) / (1 + Number(ap2) / 100 / 12) ** (i + 1);
          }
          prin -= mon - (Number(interestRate) / 12 / 100) * prin;
          discountedPmt += mon / (1 + Number(ap) / 100 / 12) ** (i + 1);
          discountedPmt2 += mon / (1 + Number(ap2) / 100 / 12) ** (i + 1);
        }
      } else if (offeringId === 2 && Number(loanAmount) / Number(homePrice) <= 0.9) {
        for (let i = 0; i < period * 12; i += 1) {
          if (i < 11 * 12) {
            totalMi += Number(mortgageInsuranceAmort(prinGovyBase, mIrate)) / (1 + Number(ap) / 100 / 12) ** (i + 1);
            totalMi2 += Number(mortgageInsuranceAmort(prinGovyBase, mIrate)) / (1 + Number(ap2) / 100 / 12) ** (i + 1);
          }
          discountedPmt += mon / (1 + Number(ap) / 100 / 12) ** (i + 1);
          discountedPmt2 += mon / (1 + Number(ap2) / 100 / 12) ** (i + 1);
          prin -= mon - (Number(interestRate) / 12 / 100) * prin;
          prinGovyBase -= monGovyBase - (Number(interestRate) / 12 / 100) * prinGovyBase;
        }
      } else {
        for (let i = 0; i < period * 12; i += 1) {
          totalMi += Number(mortgageInsuranceAmort(prinGovyBase, mIrate)) / (1 + Number(ap) / 100 / 12) ** (i + 1);
          totalMi2 += Number(mortgageInsuranceAmort(prinGovyBase, mIrate)) / (1 + Number(ap2) / 100 / 12) ** (i + 1);
          discountedPmt += mon / (1 + Number(ap) / 100 / 12) ** (i + 1);
          discountedPmt2 += mon / (1 + Number(ap2) / 100 / 12) ** (i + 1);
          prin -= mon - (Number(interestRate) / 12 / 100) * prin;
          prinGovyBase -= monGovyBase - (Number(interestRate) / 12 / 100) * prinGovyBase;
        }
      }

      totalAprPmt = Number(discountedPmt) + Number(totalMi);
      totalAprPmt2 = Number(discountedPmt2) + Number(totalMi2);

      iDiff = 0.1 * ((Number(financedAmt) - Number(totalAprPmt)) / (Number(totalAprPmt2) - Number(totalAprPmt)));
    }
  }
  return ap.toFixed(4);
};

export const propertyTax = (homePrice, propTax) => {
  let propTaxs = propTax;
  if (propTaxs <= 0.4) {
    propTaxs = 1.3;
  }
  return Math.round((propTaxs / 12 / 100) * homePrice);
};

export const upfrontMiAmt = (loanAmount, offeringId) => {
  if (offeringId === 2) {
    return loanAmount - loanAmount / 1.0175;
  } else if (offeringId === 3) {
    return loanAmount - loanAmount / 1.0215;
  } else if (offeringId === 7) {
    return loanAmount - loanAmount / 1.01;
  }
  return 0;
};

export const hazardInsu = (homePrice, hazardIns) => {
  if (hazardIns >= 0.25) {
    return Math.round((hazardIns / 12 / 100) * homePrice);
  }
  return Math.round((0.4 / 12 / 100) * homePrice);
};

export const totTaxInsAss = (homePrice, propTax, hazardIns, assessments) => {
  return Math.round(
    Number(propertyTax(homePrice, propTax)) + Number(hazardInsu(homePrice, hazardIns)) + Number(assessments),
  );
};

export const totMonPay = (
  loanAmount,
  homePrice,
  interestRate,
  mIrate,
  propTax,
  hazardIns,
  assessments,
  period,
  upFrontMI,
  offeringId,
) => {
  return Math.round(
    mortgageInsurance(loanAmount, homePrice, mIrate, upFrontMI, offeringId) +
      payment(loanAmount, interestRate, period) +
      totTaxInsAss(homePrice, propTax, hazardIns, assessments),
  );
};

export const calculateBidValues = values => {
  const pi = Math.round(payment(values.loanAmount, values.interestRate, values.period));
  const mIrate = miRates(Number(values.creditScore), Number(values.ltv), Number(values.offeringId));
  const upFrontMI = upfrontMiAmt(Number(values.loanAmount), Number(values.offeringId));
  const titleAmt = titleAmount(Number(values.homePrice), Number(values.title));
  const mi = Math.round(
    mortgageInsurance(values.loanAmount, values.homePrice, mIrate, upFrontMI, Number(values.offeringId)),
  );
  const propertyTaxVal = Math.round(propertyTax(values.homePrice, values.propTax));
  const hazardInsuranceVal = Math.round(hazardInsu(values.homePrice, values.hazardIns));

  const fiveYearsTotal = inFiveYearTotal(
    Number(values.loanAmount),
    values.interestRate,
    Number(values.homePrice),
    values.upfrontCharges,
    upFrontMI,
    mIrate,
    values.period,
    titleAmt,
    values.appraisal,
    values.otherFees,
    Number(values.offeringId),
  );

  const fiveYearsPrincipalPaid = inFiveYearPrincipal(values.loanAmount, values.interestRate, values.period);

  const apr = calculateApr(
    values.loanAmount,
    values.interestRate,
    values.upfrontCharges,
    upFrontMI,
    values.period,
    values.homePrice,
    mIrate,
    Number(values.offeringId),
  );

  const estimatedTaxes = totTaxInsAss(values.homePrice, values.propTax, values.hazardIns, values.assessments);

  const estimatedTotalMonthlyPayment = totMonPay(
    values.loanAmount,
    values.homePrice,
    values.interestRate,
    mIrate,
    values.propTax,
    values.hazardIns,
    values.assessments,
    values.period,
    upFrontMI,
  );

  return {
    ...values,
    pi,
    mIrate,
    upFrontMI,
    titleAmt,
    mi,
    propertyTaxVal,
    hazardInsuranceVal,
    fiveYearsTotal,
    fiveYearsPrincipalPaid,
    apr,
    estimatedTaxes,
    estimatedTotalMonthlyPayment,
  };
};



// WEBPACK FOOTER //
// ./src/utils/bidHelper.js